import { functionWithCondition } from '../function-with-condition/index.tsx';

/**
 * @deprecated this function does not "exists" use `functionWithFG`
 * @param featureFlagName
 * @param functionTrue
 * @param functionFalse
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const functionWithFF = <Fn extends (...args: any[]) => any>(
	featureFlagName: string,
	functionTrue: Fn,
	functionFalse: Fn,
): Fn => functionWithCondition(() => false, functionTrue, functionFalse);
